/**
 * @module app.bdc.list.formLadditionCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function FormLadditionCtrl(
        $rootScope,
        $uibModalInstance,
        $log,
        order,
        Notification,
        ladditionService,
        commonService,
        pricesService,
        orderService,
        contractTypeService
    ) {
        var self = {};

        // ======= INIT ======= init function called at the bottom of the controller

        /* Offer values*/
        self.options = ladditionService.getLadditionOptions($rootScope.orderForm.options);
        self.order = order;
        self.orderForm = $rootScope.orderForm;

        //  ======= FUNCTIONS =======

        self.getUnitPrice = pricesService.getUnitPrice;

        /* Contract */
        self.selectContractType = function selectContractType(contractTypeCode) {
            self.laddition.contractType = contractTypeService.getContractTypeByCode(contractTypeCode);
            self.updateLaddition(self.laddition);
        };

        /* Installation date */
        self.isDateInstallationOpened = false;
        self.dateInstallationOptions = {
            datepickerMode: 'month',
            maxMode: 'month',
            minMode: 'month',
            minDate: moment().toDate()
        };

        self.toggleDateInstallation = function toggleDateInstallation() {
            self.isDateInstallationOpened = !self.isDateInstallationOpened;
        };

        /* License */
        self.updateLicenseType = function updateLicenseType(type) {
            self.laddition.licenseType = type;
            if (self.laddition.options.length > 0) {
                // Reset options nbOptions attribute
                self.laddition.options.forEach(function(option) {
                    option.nbOptions = 0;
                });
                Notification.warning('Licence mise à jour - Les options ont été remises à zéro');
            }
            self.laddition.options = ladditionService.setPackIncludedOptions(
                $rootScope.orderForm.options,
                type,
                self.laddition.licensesNumber
            );
            self.maxDiscount = ladditionService.updateMaxDiscount(type, $rootScope.user);
            self.updateLaddition(self.laddition);
        };

        /**
         * Return option's label for options included with the license pack.
         * @param  {String} type license type
         * @return {Array}      Array containing label of each option
         */
        self.displayLicenseIncludedOptions = function displayLicenseIncludedOptions(type) {
            if (type && type.code) {
                return ladditionService
                    .getLicenseIncludedOptions(type, $rootScope.orderForm.options)
                    .map(function(option) {
                        return option.description ? option.description : option.label;
                    });
            }
        };

        self.removeDevice = function removeDevice() {
            if (self.laddition.licensesNumber === 0) {
                return;
            }

            self.laddition.licensesNumber--;

            if (self.laddition.licenseType.code === 'MULTI') {
                self.laddition.options.forEach(function(option) {
                    if (ladditionService.isOptionMultiDevice(option)) {
                        option.nbOptions = self.laddition.licensesNumber;
                    }
                });
            }
            self.updateLaddition(self.laddition);
        };

        self.addDevice = function addDevice() {
            self.laddition.licensesNumber++;

            if (self.laddition.licenseType.code === 'MULTI') {
                self.laddition.options.forEach(function(option) {
                    if (ladditionService.isOptionMultiDevice(option)) {
                        option.nbOptions = self.laddition.licensesNumber;
                    }
                });
            }
            self.updateLaddition(self.laddition);
        };

        /* ======= Options ======= */
        self.removeOption = function removeOption(option) {
            if (option.nbOptions === 0) {
                return;
            }

            if (option.nbOptions === 1) {
                for (var i = 0; i < self.laddition.options.length; i++) {
                    if (self.laddition.options[i].id === option.id) {
                        self.laddition.options.splice(i, 1);
                        break;
                    }
                }

                if (
                    self.feesIncluded &&
                    !orderService.isThereOptionType(self.laddition.options, 'LADDITION_MATERIEL')
                ) {
                    self.feesIncluded = false;
                    ladditionService.getFees(self.options).map(removeOption);
                    Notification.info("Plus aucune option matérielle: Frais d'envoi retirés.");
                }
            }

            option.nbOptions--;
            self.updateLaddition(self.laddition);
        };

        self.addOption = function addOption(option) {
            if (
                !orderService.isThereOptionType(self.laddition.options, 'LADDITION_MATERIEL') &&
                option.optionType.code === 'LADDITION_MATERIEL'
            ) {
                self.feesIncluded = true;
                ladditionService.getFees(self.options).map(addOption);
                Notification.info("Ajout d'une option matérielle: Frais d'envoi ajoutés.");
            }

            if (option.nbOptions === 0) {
                self.laddition.options.push(option);
            }
            option.nbOptions++;
            self.updateLaddition(self.laddition);
        };

        /* ======= FILTERS ======= */

        self.servicesFilter = function servicesFilter(option) {
            if (option.reference === 'FORMASITE' || option.reference === 'FORMACARTE') {
                return commonService.endsWith(option.label, self.laddition.licenseType.code || ''); // Filtering FORMASITE and FORMACARTE options according to license type
            }
            else {
                return option.optionType.code === 'LADDITION_SERVICE' && option.reference !== 'MES'; // MES option is included with each type of license
            }
        };

        self.hardwareFilter = function hardwareFilter(option) {
            return option.optionType.code === 'LADDITION_MATERIEL' || option.optionType.code === 'LADDITION_TPE';
        };

        self.feesFilter = function feesFilter(fee) {
            return fee.optionType.code === 'LADDITION_FRAIS';
        };

        /* ======= Globals ======= */

        function init() {
            if (self.order.contract.isLaddition) {
                $log.info("offre l'addition déjà présente", self.order.laddition);
                self.laddition = self.order.laddition;
                self.laddition.options = ladditionService.getLadditionOptions(self.order.options);
                self.dateInstallation = self.laddition.dateInstallation
                    ? moment(self.laddition.dateInstallation).toDate()
                    : null;
                self.feesIncluded = orderService.isThereOptionType(self.laddition.options, 'LADDITION_FRAIS');
                self.maxDiscount = ladditionService.updateMaxDiscount(self.laddition.licenseType.code, $rootScope.user);
                self.updateLaddition(self.laddition);
            }
            else {
                self.laddition = {
                    options: [],
                    licensesNumber: 0,
                    dateInstallation: null,
                    licenseType: {
                        id: null,
                        code: null,
                        label: null
                    }
                };

                self.feesIncluded = false;
                self.maxDiscount = 0;
            }
        }

        self.updateLaddition = function updateLaddition(laddition) {
            self.laddition.totalPrice = ladditionService.calculateLadditionPrice(laddition);
        };

        self.submitLaddition = function submitLaddition() {
            self.laddition.dateInstallation = self.dateInstallation
                ? moment(self.dateInstallation).format('YYYY-MM-DD')
                : null;

            if (
                self.laddition.licenseType.code === 'MONO' &&
                ladditionService.getDeviceAmount(self.laddition.options) > 1
            ) {
                Notification.warning('Offre avec licence MONO : plusieurs terminaux ont été ajoutés');
            }

            if (!ladditionService.isOfferDefined(self.laddition)) {
                Notification.error(ladditionService.getOfferNotDefinedMessage(self.laddition));
                return;
            }

            if (self.laddition.licenseType.code === 'MULTI' && self.laddition.licensesNumber < 2) {
                Notification.error('Offre avec licence MULTI : Veuillez ajouter au moins 2 licences');
                return;
            }

            if (
                self.laddition.licenseType.code === 'MULTI' &&
                ladditionService.getDeviceAmount(self.laddition.options) > self.laddition.licensesNumber
            ) {
                Notification.error('Offre avec licence MULTI : Il y a plus de terminaux que de licences ajoutées');
                return;
            }

            self.order.contract.isLaddition = true;
            self.order.contract.contractType = self.laddition.contractType;
            self.order.laddition = self.laddition;

            self.close();
        };

        /* Modal functions */

        self.close = function close() {
            $log.info(self.laddition);
            $uibModalInstance.close(self.laddition);
        };

        self.cancel = function cancel() {
            $uibModalInstance.dismiss('cancel');
        };

        init();

        return self;
    }

    FormLadditionCtrl.$inject = [
        '$rootScope',
        '$uibModalInstance',
        '$log',
        'order',
        'Notification',
        'ladditionService',
        'commonService',
        'pricesService',
        'orderService',
        'contractTypeService'
    ];

    angular
        .module('app.bdc.list.formLadditionCtrl', ['ui.bootstrap.modal'])
        .controller('FormLadditionCtrl', FormLadditionCtrl);
});
